import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Spin } from "antd";
import PhoneInput from "react-phone-number-input";
import phoneIcon from "../../../../../../assets/images/phone.svg";
import whatsappIcon from "../../../../../../assets/images/watsapp.svg";
import webIcon from "../../../../../../assets/images/website.svg";
import mailIcon from "../../../../../../assets/images/mail.svg";
import "./PersonalInfoForm.scss";
import userServiceApi from "../../../../../../api/userServiceApi";
import { toast } from "react-toastify";
import {
  getRequest,
  postRequest,
  putRequest,
} from "../../../../../../api/http";
import { useLocation } from "react-router-dom";
import EmptyTabWarning from "../../../../../common/EmptyTabWarning";
import { usePublishedEmptyTabWarning } from "../../../../../../custom-hooks/usePublishedEmptyTabWarning";

const PersonalInfoForm = ({ tabKey }) => {
  const location = useLocation();
  const micrositeId = location.pathname.split("/")[1];
  const tabConfigId = localStorage.getItem("selectedTabId");

  const [form] = Form.useForm();

  const [disabledSave, setDisabledSave] = useState(true);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabApiData, setTabApiData] = useState(undefined);
  const [tabApiLoaded, setTabApiLoaded] = useState(false);
  const { show: showEmptyTabWarning, tabName: emptyTabName } =
    usePublishedEmptyTabWarning({
      tabKey,
      data: tabApiData,
      loaded: !loading && tabApiLoaded,
    });

  const getTabInfo = async () => {
    setLoading(true);
    try {
      const res = await getRequest(
        userServiceApi.getContactUsDetails(tabKey, micrositeId)
      );
      if (res?.status === 200 && Array.isArray(res.data)) {
        setTabApiData(res.data);
        setTabApiLoaded(true);
      }
      const data = res?.data[0];
      setData(data);
      form.setFieldsValue({
        phone: data?.phone || null,
        email: data?.email || null,
        whatsapp: data?.chatNumber || null,
        website: data?.websiteLink || null,
      });
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
    setLoading(false);
  };

  const renderLabel = (iconSrc, labelText) => (
    <div className="align-div-items-center">
      <div className="min-width-24">
        <img src={iconSrc} alt={labelText} className="margin-right-3" />
      </div>
      {labelText}
    </div>
  );

  const handleSave = async (values) => {
    try {
      const payload = {
        phone: values.phone ?? null,
        email: values.email ?? null,
        chatNumber: values.whatsapp ?? null,
        websiteLink: values.website ?? null,
        contactUsTypeEnum: tabKey,
      };
      if (data?.id) {
        payload.contactUsId = data?.id;
        const res = await putRequest(
          userServiceApi.updateContactUsSales(data?.id),
          payload
        );
        if (res) {
          toast.success("Updated successfully");
        }
      }
      if (!data?.id) {
        const res = await postRequest(
          userServiceApi.addContactUsDetails(micrositeId, tabConfigId),
          payload
        );
        if (res) {
          toast.success("Created successfully");
        }
      }
      getTabInfo();
      setDisabledSave(true);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleFormChange = () => {
    setDisabledSave(
      form.isFieldsTouched() &&
        form.getFieldsError().some(({ errors }) => errors.length)
    );
  };

  useEffect(() => {
    if (tabKey && micrositeId) {
      getTabInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabKey, micrositeId]);

  if (loading) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  return (
    <>
      {showEmptyTabWarning && <EmptyTabWarning tabName={emptyTabName} />}
      <Col span={15}>
      <Form
        form={form}
        initialValues={{}}
        layout="horizontal"
        onFinish={handleSave}
        className="personal-form"
        onFieldsChange={handleFormChange}
      >
        <Form.Item
          label={renderLabel(phoneIcon, "Phone")}
          labelCol={{ span: 4 }}
          name="phone"
          // rules={[{ required: true, message: "Please enter phone number." }]}
        >
          <PhoneInput
            className="custom-phone-input"
            defaultCountry="GB"
            placeholder="Enter phone number"
            focusInputOnCountrySelection
          />
        </Form.Item>
        <Form.Item
          label={renderLabel(mailIcon, "Email")}
          labelCol={{ span: 4 }}
          name="email"
          rules={[
            // {
            //   required: true,
            //   message: "Please enter email address.",
            // },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input placeholder="Enter email address" />
        </Form.Item>
        <Form.Item
          label={renderLabel(whatsappIcon, "Whatsapp")}
          labelCol={{ span: 4 }}
          name="whatsapp"
        >
          <Input placeholder="Enter whatsapp number" />
        </Form.Item>
        <Form.Item
          label={renderLabel(webIcon, "Website")}
          labelCol={{ span: 4 }}
          name="website"
          rules={[
            // {
            //   required: true,
            //   message: "Please enter website.",
            // },
            { type: "url", message: "Enter a valid URL" },
          ]}
        >
          <Input placeholder="Enter website" />
        </Form.Item>
        <Form.Item>
          <div className="align-div-items-end">
            <Button
              disabled={disabledSave}
              className={`saveBtn greenBtn ${
                disabledSave ? "save-btn-disabled" : ""
              }`}
              htmlType="button"
              onClick={() => form.submit()}
            >
              Save
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Col>
    </>
  );
};

export default PersonalInfoForm;
